import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import { CustomListItemProps } from "@propTypes/index";
import { useNavigate } from "react-router-dom";
import { AppBarStyle } from "../../../customStyles/index";
import { useCustomModalStore, useUserStore } from "../../../state";
import { urls } from '../../../urls';

const CustomListItem: React.FC<CustomListItemProps> = ({ children, dataTestId, expandable, lastTopItem = false, pageName, expanded, label, openMenu, handleToggleMenu, handleDrawerOpen, setOpen }) => {
    const navigate = useNavigate();
    const userConfig = useUserStore(state => state.userConfig)
    const { userGroup, userEmail } = userConfig;

    const setDialogStyles = useCustomModalStore(state => state.setDialogStyles)
    const setOpenCustomModal = useCustomModalStore(state => state.setOpenCustomModal)
    const setCustomModalTitle = useCustomModalStore(state => state.setCustomModalTitle)
    const setContentText = useCustomModalStore(state => state.setContentText)
    const setContentStyle = useCustomModalStore(state => state.setContentStyle)
    const setProgressVariant = useCustomModalStore(state => state.setProgressVariant)
    const setModalActionsConfig = useCustomModalStore(state => state.setModalActionsConfig)
    const handleLink = (page: string) => {
        if (page !== "reports") {
            navigate(`/app/${page}`)
        } else {

            setCustomModalTitle("Redirect Notice")

            const fetchEmbedUrl = async () => {
                const controller = new AbortController();
                const { signal } = controller;
                const url = urls.REPORTING;
                let fetchUrl = `${process.env.NODE_ENV === 'production' ? url : ""}/reporting/embeddedDashboardUrl`

                setContentText("Redirecting to reports dashboard.")
                setDialogStyles({ height: "200px" })
                setContentStyle({ display: "flex", flexDirection: "column", justifyContent: "space-evenly" })
                setProgressVariant("indeterminate")
                setModalActionsConfig([])
                setOpenCustomModal(true)

                try {
                    const resp = await fetch(fetchUrl, {
                        method: "POST",
                        credentials: "include",
                        body: JSON.stringify({
                            email: userEmail,
                            group: userGroup
                        }),
                        signal
                    });

                    console.log('error resp: ', resp)
                    if (resp.status !== 200) {
                        setContentText("Error retrieving reports.")
                        setProgressVariant(undefined)
                        setModalActionsConfig([
                            {
                                onClick: () => setOpenCustomModal(false),
                                variant: "contained",
                                buttonTitle: "Cancel"
                            },
                            {
                                onClick: fetchEmbedUrl,
                                variant: "contained",
                                buttonTitle: "Retry"
                            }

                        ])
                    } else {
                        const { embedUrl } = await resp.json()

                        window.open(embedUrl, '_blank')
                        setOpenCustomModal(false)


                    }

                } catch (err: any) {
                    console.log('use dashboard url error: ', err);
                }
            }
            fetchEmbedUrl()
        }
    }

    const listItemStyle = {
        alignItems: "flex-end",
        display: "flex",
        ...(lastTopItem === true && { flex: 1 })
    }

    return (
        <>
            {(
                pageName !== "administration" && pageName !== "reports" && pageName !== "rapback-subscriptions"
                    ? <ListItem data-testid={dataTestId} disablePadding sx={{ ...listItemStyle, display: 'block' }}>
                        <ListItemButton data-testid={`${dataTestId}-button`} onClick={() => {
                            handleLink(pageName);
                            setOpen(false);
                        }
                        }
                            sx={{ ...AppBarStyle.listItemButtonStyle, justifyContent: expanded ? 'initial' : 'center' }} aria-label={label}>
                            <ListItemIcon sx={{ mr: expanded ? 0 : 'auto', justifyContent: expanded ? "space-between" : "center", }}>
                                {children}
                            </ListItemIcon>

                            <ListItemText primary={label} sx={{ opacity: expanded ? 1 : 0, "&.MuiListItemText-root": { textWrap: "wrap", width: "100%" } }} />

                        </ListItemButton>
                    </ListItem>

                    : <ListItem disablePadding sx={{ ...listItemStyle, display: "block" }}>
                        <ListItemButton data-testid={`${dataTestId}-button`} onClick={expandable ? () => {
                            handleDrawerOpen?.()
                            handleToggleMenu?.()
                        } : () => {
                            handleLink(pageName)
                        }}
                            sx={{ ...AppBarStyle.listItemButtonStyle, justifyContent: expanded ? 'initial' : 'center' }}
                            aria-label={label}
                        >
                            <ListItemIcon sx={{ minWidth: 0, mr: expanded ? 3 : 'auto', justifyContent: 'center', }}>
                                {children}
                            </ListItemIcon>
                            <ListItemText primary={label} sx={{ opacity: expanded ? 1 : 0, "&.MuiListItemText-root": { textWrap: "wrap" } }} />
                            {
                                expanded && (
                                    (expandable && openMenu
                                        ? <ExpandLessIcon onClick={(e) => {
                                            e.stopPropagation()
                                            handleToggleMenu?.()
                                        }} />
                                        : !expandable
                                            ? <OpenInNewIcon color="action" />
                                            : <ExpandMoreIcon onClick={(e) => {
                                                e.stopPropagation()
                                                handleToggleMenu?.()
                                            }} />
                                    ))
                            }
                        </ListItemButton>
                    </ListItem>
            )}
        </>
    )
}

export default CustomListItem;